export let assistancesObject = {
  id: '',
  working_date: '',
  entry_time: '',
  exit_time: '',
  employee: null,
}
